import { render, staticRenderFns } from "./FuneralService.vue?vue&type=template&id=70525a1c&scoped=true&"
import script from "./FuneralService.vue?vue&type=script&lang=js&"
export * from "./FuneralService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70525a1c",
  null
  
)

export default component.exports